// idees
// return log lengths
// calc time to sleep and return > need historical data
// detect overload if logs length === 0 > increase priority
// jumb to short polling > slower times 2
var connections = [];
var _serverIsOverloaded = false;
if (typeof window === "object" && window.api_util) {
    var lastTimeStampOverloadCookie = api_util.get_cookie("com.nixps.server-overload");
    if (typeof lastTimeStampOverloadCookie === "string" && lastTimeStampOverloadCookie.length > 0) {
        _serverIsOverloaded = true;
    }
}

/**
 * @constructor WhitepaperConnection
 * @description An object containing a connection to a whitepaper. With this you have an api like call to workflows. Create the object with the settings.
 * Call the start function and wait for the results, via a $.Deferred. This handles the polling itself.
 * @param {String} pWhitepaperName The name of the workflow
 * @param {String} pWhitepaperInputName The input name of the "Start from Kiosk" or the "Start from Web request"
 * @param {Object} pInputParameters The input parameters to be given to the "Start from ..." node
 * @param {Object} pConnection settings for the Start with DBIO, leave undefined for "Start from Kiosk and Start from Web Request"
 * @param {Boolean} pLongLive prevent stopping if leaving page, this connection may not be automaticaly aborted. Default is false 
 * @example var connection = new WhitepaperConnection("WhitepaperTest", "Input Name", {"type": "test", "value": 42})
 * @return {nm$_WhitepaperConnection.WhitepaperConnection}
 */
function WhitepaperConnection(pWhitepaperName, pWhitepaperInputName, pInputParameters, pConnection, pLongLive, pFiles) {
    this._setWhitepaper(pWhitepaperName);
    this._setWhitepaperInput(pWhitepaperInputName);
    this._setConnection(pConnection);
    this._setInputParameters(pInputParameters);
    this._setFiles(pFiles);
    if (window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.LogListener !== undefined) {
        this._setForceFirstPolling(nixps.cloudflow.LogListener.isActive());
    } else {
        this._setForceFirstPolling(false);
    }
    this.setStartPollingTime(3);
    this.setPollingTime(3);
    this.workableID = null;
    this.jacketID = null;
    this.isDead = false;
    this.reasonToStop = null;
    this.started = false;
    this.startDate = null;
    this.tooLongBussy = false;
    connections.push(this);
    this.longlive = false; 
    this._setLongLive(pLongLive);
    this.eventListenersDict = {};
    this.timeoutID = undefined;
    this.pauseStatus = "running";
    this.pausePromise = null;
};

WhitepaperConnection.prototype = {

    constructor: WhitepaperConnection,

    _setWhitepaper: function(pWhitepaperName){
        if (typeof pWhitepaperName !== "string" || pWhitepaperName.length <= 0) {
            throw new Error("parameter whitepapername must be a not emtpy string");
        }
        this.whitepaper = pWhitepaperName;
    },
    
    _setWhitepaperInput: function(pWhitepaperInputName) {
        if (typeof pWhitepaperInputName !== "string" || pWhitepaperInputName.length <= 0) {
            throw new Error("parameter whitepapername must be a not emtpy string");
        }
        this.inputname = pWhitepaperInputName;
    },
    
    _setConnection: function(pConnection) {
        if (pConnection && pConnection.connectionType === "database_proxy") {
            this.connectionType = "database_proxy";
            this.connectionFunctionName = pConnection.connectionFunctionName;
            this.connectionCallOptions = pConnection.connectionCallOptions;
        } else {
            this.connectionType = "hub";
            this.connectionFunctionName = "start_from";
            this.connectionCallOptions = {};
        }
    },
    
    _setInputParameters: function(pInputParameters) {
        if (this.connectionType === "hub") {
            if (pInputParameters === undefined || pInputParameters === null) {
                this.inputparameters = {};
                return;
            }
            if (typeof pInputParameters !== "object" || Array.isArray(pInputParameters)) {
                throw new Error("parameter pInputParameters must be a plain object");
            }
            this.inputparameters = structuredClone(pInputParameters);
        } else {
            if (pInputParameters === undefined || pInputParameters === null) {
                this.inputparameters = [];
                return;
            }
            if (Array.isArray(pInputParameters) === false) {
                throw new Error("parameter pInputParameters must be an array");
            }
            this.inputparameters = pInputParameters;
        }
    },

    _setFiles: function(pFiles){
        if (Array.isArray(pFiles)) {
            this.files = pFiles.slice(); // copy
        } else {
            this.files = null;
        }
    },
    
    _setLongLive: function(pLongLive) {
        if (pLongLive === true) {
            this.longlive = true;
        } else {
            // default value
            this.longlive = false; 
        }
    },

    /**
     * @description set if we need to force the first polling or not, is justed durring debugging
     * @function
     * @name WhitepaperConnection#_setForceFirstPolling
     * @private
     * @param {Boolean} pForceFirstPolling 
     * @returns {undefined}
     */
    _setForceFirstPolling: function(pForceFirstPolling){
        if (pForceFirstPolling === true) {
            this.forceFirstPolling = true;
        } else {
            this.forceFirstPolling = false;
        }
    },

    /**
     * @description Set the first timeout during start up on a different number.
     * @name WhitepaperConnection#setStartPollingTime
     * @function 
     * @param {Number} pStartPollingTime The delay in seconds
     * @return {undefined}
     */
    setStartPollingTime: function(pStartPollingTime) {
        if (typeof pStartPollingTime !== "number" || pStartPollingTime <= 0) {
            throw new Error("setStartPollingTime parameter must be a positive number");
        }
        this.startPollingTime = pStartPollingTime;
    },
    
    /**
     * @description Set delay between pollings on a different number (not the first one)
     * @name WhitepaperConnection#setPollingTime
     * @function
     * @param {Number} pPollingTime The delay in seconds
     * @return {undefined}
     */
    setPollingTime: function(pPollingTime) {
        if (typeof pPollingTime !== "number" || pPollingTime <= 0) {
            throw new Error("setPollingTime parameter must be a positive number");
        }
        this.pollingTime = pPollingTime;
    },
    
    /**
     * @description Check if the whitepaper and input exits or not?
     * @name WhitepaperConnection#exist
     * @function
     * @returns {Deferred} true if the whitepaper exists, false otherwise
     */
    exist: function() {
        return WhitepaperConnection.exist(this.whitepaper, this.inputname);
    },
    
    /**
     * @name WhitepaperConnection#getWorkableID
     * @description Get the current workable id if the polling has entered the first state or null
     * @function
     * @return {String} workableId or null
     */
    getWorkableID: function(){
        return this.workableID;
    },
    
    /**
     * @name WhitepaperConnection#getJacketID
     * @description Get the current jacket id if the polling has entered the first state or null
     * @function
     * @return {String} workableId or null
     */
    getJacketID: function(){
        return this.jacketID;
    },
    
    /**
     * @description Must we use short or long polling
     * @function
     * @name WhitepaperConnection#_needShortPolling
     * @private
     * @returns {Boolean} true if we need to convert to short polling
     */
    _needShortPolling: function(){
        return _serverIsOverloaded === true || this.tooLongBussy === true;
    },

    /**
     * @description Add an callbackfunction for an event
     * @function
     * @name WhitepaperConnection#addEventListener
     * @param {String} pEventName the name of the event
     * @param {Function} pFunction the callback function when the event occured
     */
    addEventListener: function(pEventName, pFunction) {
        if (typeof pEventName !== "string" || pEventName.length <= 0) {
            throw new Error("parameter pEventname is missing");
        }
        if (typeof pFunction !== "function") {
            throw new Error("The eventlistener must be a function");
        }
        if (this.eventListenersDict[pEventName] === undefined) {
            this.eventListenersDict[pEventName] = [];
        }
        this.eventListenersDict[pEventName].push(pFunction);
    },

    /**
     * @description Remove an callbackfunction for an event, if no link found, it ignores
     * @function
     * @name WhitepaperConnection#removeEventListener
     * @param {String} pEventName the name of the event
     * @param {Function} pFunction the callback function when the event occured
     */
    removeEventListener: function(pEventName, pFunction) {
        if (typeof pEventName !== "string" || pEventName.length <= 0) {
            throw new Error("parameter pEventname is missing");
        }  
        if (typeof pFunction !== "function") {
            throw new Error("The eventlistener must be a function");
        }
        if (Array.isArray(this.eventListenersDict[pEventName]) && this.eventListenersDict[pEventName].length > 0) {
            for(var i = this.eventListenersDict[pEventName].length-1; i>=0; i--) {
                if (this.eventListenersDict[pEventName][i] === pFunction) {
                    this.eventListenersDict[pEventName].splice(i, 1);
                }
            }
        } 
    },

    _dispatchEvent: function(pEventName, pEvent, pData){
        if (typeof this["on" + pEventName] === "function") {
            this["on" + pEventName](pEvent, pData);
        }
        if (Array.isArray(this.eventListenersDict[pEventName]) && this.eventListenersDict[pEventName].length > 0) {
            for(var i=0; i<this.eventListenersDict[pEventName].length; i++) {
                this.eventListenersDict[pEventName][i](pEvent, pData);
            }
        }
    },

    /**
     * @description check if a workable has already been started or not.
     * @function
     * @name WhitepaperConnection#isStarted
     * @returns {Boolean} true if the workable has started already
     */
    isStarted: function() {
        return this.started === true;
    },
    
    /**
     * @function
     * @description Check if the workable has been stopped by the stop methode 
     * @name  WhitepaperConnection#isAlive
     * @returns {Boolean} true if the workable has been aborted by the stop or not 
     */
    isAlive: function() {
        return this.isDead === false;
    },
    
    /**
     * @description Is the connection a long live allowed?
     * @function
     * @name WhitepaperConnection#hasLongLive
     * @returns {Boolean} true if the connection may live longer, false otherwise
     */
    hasLongLive: function(){
        return this.longlive;
    },

    /**
     * @description check if the connection known he need to pause
     * @function
     * @name WhitepaperConnection#isPaused
     * @returns {Boolean} true if the connection knows it need to pause
     */
    isPaused: function(){
        return this.pauseStatus === "waiting";
    },

    /**
     * @description pause the connection, it will stop polling on the next cycle
     * @function
     * @name WhitepaperConnection#pause
     * @returns {undefined}
     */
    pause: function(){
        if (this.isStarted() === false) {
            console.warn("pause asked when connection is not started yet");
        }
        this.pauseStatus = "waiting";
    },

    /**
     * @description restart polling when the connection is paused
     * @function
     * @name WhitepaperConnection#resume
     * @returns {undefined}
     */
    resume: function(){
        if (this.isPaused() && this.isAlive()) {
            this.pauseStatus = "running";
            if (this.pausePromise && typeof this.pausePromise.then === "function") {
                // restart polling
                this._polling(this.pausePromise);
            } else if (this.pausePromise === null){
                // we resume before it could catch the next polling
            } 
        }
    },

    /**
     * @name WhitepaperConnection#stop
     * @description Stop the polling and clean up, the user is not interested anymore in the results
     * @function
     * @return {undefined}
     */
    stop: function(pReason) {
        if (this.isAlive() === false) {
            return; // prevent killing dead connections ...
        }
        this._stop(pReason);
        if (this.getWorkableID() !== null && window.api_async !== undefined && api_async.hub !== undefined) {
            var that = this;
            // only in case we have a workable id
            api_async.hub.abort_workable(this.getWorkableID(), false, function() {

            }, function(pError) {
                console.error(pError);
            });
        }
        clearTimeout(this.timeoutID);
    },
    
    /**
     * @name WhitepaperConnection#_stop
     * @description Function runs when the connection is closed
     * @function
     * @private
     * @return {undefined}
     */
    _stop: function(pReason) {
        this.isDead = true;
        if (typeof pReason === "string") {
            this.reasonToStop = pReason;
        } else {
            this.reasonToStop = "???";
        }
        // remove yourself of the list and do this async
        var that = this;
        setTimeout(function(){
            for (var i=0; i<connections.length; i++) {
                if (connections[i] === that) {
                    connections.splice(i, 1);
                    break;
                }
            }
        });
    },
    
    /**
     * @name WhitepaperConnection#start
     * @description Start the workflow
     * @function
     * @return {Deferred}
     */
    start: function() {
        if (this.isStarted() === true) {
            return $.Deferred().reject({"error": "no_restart"});
        }
        this.started = true;
        this.startDate = new Date();
        if (this.connectionType === "hub") {
            return this._startHub();
        } else {
            return this._startProxy();
        }
    },
    
    _startHub: function(){
        var that = this;
        if (this.forceFirstPolling === true || this.isPaused()) {
            // polling time is minimum a second, can not be smaller,
            // so do a normal start which garanties us a "jacket_id" and "workable_id"
            return $.Deferred(function(pDefer){
                that.justStart(true).then(function(){ 
                    that._polling(pDefer); 
                }, pDefer.reject);
            });
        }
        return $.Deferred(function(pDefer){
            var processDef;
            if (Array.isArray(that.files)) {
                processDef = api_defer.hub.process_from_whitepaper_with_files_and_variables(that.whitepaper, that.inputname, that.files, that.inputparameters, that._needShortPolling() ? 0.1 : that.startPollingTime);
            } else {
                processDef = api_defer.hub.process_from_whitepaper_with_variables(that.whitepaper, that.inputname, that.inputparameters, that._needShortPolling() ? 0.1 : that.startPollingTime);
            }
            processDef.then(function(pResults) {
                // do we get results ??
                if (pResults !== undefined && pResults.timed_out === true && pResults.workable_id !== undefined) {
                    that.workableID = pResults.workable_id;
                    that.jacketID = pResults.jacket_id;

                    if (that.isAlive() === false) {
                        pDefer.reject({
                            "error": "stop_called", 
                            "error_reason": that.reasonToStop,
                            "debug": {
                                "debug_type": "workflow",
                                "whitepaperName": that.whitepaper,
                                "whitepaperInputName": that.inputname
                            }
                        });
                        return;
                    }

                    var progressData = {
                        workableID: that.workableID, 
                        jacketID: that.jacketID,
                        nodeName: pResults.node_name,
                        milestone: pResults.milestone,
                        pollingCount: 0
                    };
                    pDefer.notify(progressData);
                    that._dispatchEvent("progress", new ProgressEvent("progress", {lengthComputable: false}), progressData);
                    that._polling(pDefer);
                } else if (pResults !== undefined && pResults.no_results === true) {
                    that.workableID = pResults.workable_id;
                    that.jacketID = pResults.jacket_id;
                    var debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
                    console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
                    pDefer.reject({
                        "error": "no_results",
                        "debug": {
                            "debug_type": "workflow",
                            "whitepaperName": that.whitepaper,
                            "whitepaperInputName": that.inputname,
                            "jacketID": pResults.jacket_id,
                            "workableID": pResults.workable_id,
                            "nodeName": pResults.node_name
                        }
                    });
                } else if (pResults !== undefined && pResults.status === 303 && 
                    typeof pResults.content_type === "string" && pResults.contents !== undefined) {
                        if (typeof pResults.contents === "string" && pResults.contents.length > 0) {
                            var progressData = {action: "redirect", url: pResults.contents, defer: pDefer};
                            pDefer.notify(progressData);
                            that._dispatchEvent("progress", new ProgressEvent("progress", {lengthComputable: true, total: 1, loaded: 1}), progressData);
                        } else {
                            pDefer.reject({
                                "error": "no_link_redirect",
                                "debug": {
                                    "debug_type": "workflow",
                                    "whitepaperName": that.whitepaper,
                                    "whitepaperInputName": that.inputname
                                }
                            });
                        }
                } else if (pResults !== undefined && pResults.status >= 500 && pResults.status <= 599) {
                    pDefer.reject(pResults.contents);
                } else {
                    that._stop("end_success_call");
                    pDefer.resolve(pResults);
                } 
            },
            function(pError){
                console.error(pError);
                pDefer.reject(pError);
            });
        });
    },
    
    _startProxy: function(){
        var that = this;
        return $.Deferred(function(pDefer) {
            var goodCallBack = function(pResults) {
                // do we get results ??
                if (pResults !== undefined && pResults.timed_out === true && pResults.workable_id !== undefined) {
                    if (that.isAlive() === false) {
                        pDefer.reject({
                            "error": "stop_called", 
                            "error_reason": that.reasonToStop, 
                            "debug": {
                                "debug_type": "workflow",
                                "whitepaperName": that.whitepaper,
                                "whitepaperInputName": that.inputname
                            }});
                        return;
                    }
                    that.workableID = pResults.workable_id;
                    that.jacketID = pResults.jacket_id;
                    var progressData = {
                        workableID: that.workableID, 
                        jacketID: that.jacketID, 
                        nodeName: pResults.node_name,
                        milestone: pResults.milestone,
                        pollingCount: 0
                    }
                    pDefer.notify(progressData);
                    that._dispatchEvent("progress", new ProgressEvent("progress", {lengthComputable: false}), progressData);
                    that._polling(pDefer);
                } else if (pResults !== undefined && pResults.no_results === true) {
                    var debugURL;
                    if (typeof pResults.workable_id === "string" && pResults.workable_id.length > 0) {
                        that.workableID = pResults.workable_id;
                        that.jacketID = pResults.jacket_id;
                        debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
                    } else {
                        debugURL = "/portal.cgi?quantum&whitepaperName=" + that.whitepaper;
                    }
                    console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
                    pDefer.reject({
                        "error": "no_results",
                        "debug": {
                            "debug_type": "workflow",
                            "whitepaperName": that.whitepaper,
                            "whitepaperInputName": that.inputname,
                            "jacketID": pResults.jacket_id,
                            "workableID": pResults.workable_id,
                            "nodeName": pResults.node_name
                        }
                    });
                } else {
                    that._stop("end_success_call");
                    pDefer.resolve(pResults);
                } 
            };
            var errorCallback = function(pError){
                    console.error(pError);
                    pDefer.reject(pError);
                };
            if (that.forceFirstPolling === true || that.isPaused() || that._needShortPolling()) {
                that.connectionCallOptions.time_out = 0.1;
            } else {
                that.connectionCallOptions.time_out = that.startPollingTime;
            }
            var apiCallArguments = [{"whitepaper_name": that.whitepaper, "input_name": that.inputname}].concat(that.inputparameters); 
            apiCallArguments = apiCallArguments.concat([that.connectionCallOptions, goodCallBack, errorCallback]);
            api_async.database_proxy[that.connectionFunctionName].apply(api_async.database_proxy, apiCallArguments);
        });
    },
    
    
    _polling: function(pDefer) {
        var that = this;
        // prevent loop when pauze is activated
        if (this.pauseStatus === "waiting") {
            if (this.pausePromise === null) {
                this.pausePromise = pDefer;
            }
            return;
        }
        // if user need to wait too long, swith to short polling
        if (this.tooLongBussy === false && this.startDate && (+this.startDate + 15000 < +(new Date()))) {
            this.tooLongBussy = true;
        }
        
        var pollingDef;
        if (this._needShortPolling() === false) {
            // normal process
            pollingDef = this._pollResults(pDefer);
        } else {
            // panic mode
            clearTimeout(this.timeoutID);
            pollingDef = $.Deferred();
            var timeToWait;
            if (_serverIsOverloaded === true) {
                timeToWait = Math.min(2147483600 - 1, Math.max(this.pollingTime, 5) * 1000);
            } else if (this.tooLongBussy === true) {
                timeToWait = Math.min(2147483600 - 1, this.pollingTime * 1000);
            } else { // should not come here
                timeToWait = Math.max(this.pollingTime * 1000, 4);
            }
            this.timeoutID = setTimeout(function(){
                that._pollResults(pDefer).then(pollingDef.resolve, pollingDef.reject);
            }, timeToWait)
        }
        pollingDef
        .done(function(pResults) {
            that._stop("end_success_call");
            pDefer.resolve(pResults);
        }).fail(function(pError){
            if (that.isAlive() === false) {
                // do nothing, 
                // just prevent further action, if element is zomby
                pDefer.reject({
                    "error": "stop_called", 
                    "error_reason": that.reasonToStop,
                    "debug": {
                        "debug_type": "workflow",
                        "whitepaperName": that.whitepaper,
                        "whitepaperInputName": that.inputname
                    }});
                return;
            } else if (pError === "wait") {
                that._polling(pDefer);
            } else {
                console.error(pError);
                if (pError && pError.debug === undefined) {
                    pError.debug = {
                        "debug_type": "workflow",
                        "whitepaperName": that.whitepaper,
                        "whitepaperInputName": that.inputname,
                        "jacketID": that.jacketID,
                        "workableID": that.workableID,
                    }
                    if (pError.error_code === "Workable does not exist") {
                        delete pError.debug.jacketID;
                        delete pError.debug.workableID;
                    }
                }
                pDefer.reject(pError);
            }
        });
    },
    
    _pollResults: function(pDefer) {
        if (this.connectionType === "hub") {
            return this._pollResultsHub(pDefer);
        } else {
            return this._pollResultsProxy(pDefer);
        }
    },
    
    _pollResultsHub: function(pPreviousDefer) {
        var that = this;
        return $.Deferred(function(pDefer) {
            api_async.hub.poll_for_workable_result(that.workableID, that._needShortPolling() ? 0.1 : that.pollingTime,  function(pResults) {
                if (pResults !== undefined && pResults.timed_out === true) {
                    if (typeof pResults.milestone === "string" || typeof pResults.node_name === "string") {
                        var progressData = {
                            workableID: that.workableID, 
                            jacketID: that.jacketID, 
                            nodeName: pResults.node_name,
                            milestone: pResults.milestone
                        };
                        pPreviousDefer.notify(progressData);
                        that._dispatchEvent("progress", new ProgressEvent("progress", {lengthComputable: false}), progressData);
                    }
                    // waiting
                    pDefer.reject("wait");
                } else if (pResults !== undefined && pResults.no_results === true) {
                    var debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
                    console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
                    pDefer.reject({
                        "error": "no_results", 
                        "debug": {
                            "debug_type": "workflow",
                            "whitepaperName": that.whitepaper,
                            "whitepaperInputName": that.inputname,
                            "jacketID": pResults.jacket_id,
                            "workableID": pResults.workable_id,
                            "nodeName": pResults.node_name
                        },
                        "milestone": pResults.milestone
                    });
                } else if (pResults !== undefined && pResults.result !== undefined && 
                        pResults.result.status === 303 &&
                        typeof pResults.result.content_type === "string" && pResults.result.contents !== undefined) {
                            if (typeof pResults.result.contents === "string" && pResults.result.contents.length > 0) {
                                var progressData = {action: "redirect", url: pResults.result.contents, defer: pPreviousDefer};
                                pPreviousDefer.notify(progressData);
                                that._dispatchEvent("progress", new ProgressEvent("progress", {lengthComputable: true, total: 1, loaded: 1}), progressData);
                            } else {
                                var debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
                                console.error("debug: " + window.location.origin + debugURL);
                                pDefer.reject({
                                    "error": "no_link_redirect", 
                                    "debug": {
                                        "debug_type": "workflow",
                                        "whitepaperName": that.whitepaper,
                                        "whitepaperInputName": that.inputname,
                                        "jacketID": pResults.jacket_id,
                                        "workableID": pResults.workable_id,
                                        "nodeName": pResults.node_name
                                    }
                                });
                            }
                } else if (pResults !== undefined && pResults.result !== undefined && pResults.result.status >= 500 && pResults.result.status <= 599){
                    pDefer.reject(pResults.result.contents);
                } else {
                    pDefer.resolve(pResults.result);
                } 
            }, function(pError){
               console.error(pError);
               pDefer.reject(pError);
            });
        });
    },
    
    _pollResultsProxy: function(pPreviousDefer){
        var that = this;
        return $.Deferred(function(pDefer) {
            api_async.database_proxy.poll_for_result(that.workableID, that._needShortPolling() ? 0.1 : that.pollingTime,  function(pResults) {
                if (pResults !== undefined && pResults.timed_out === true) {
                    if (typeof pResults.milestone === "string" || typeof pResults.node_name === "string") {
                        var progressData = {
                            workableID: that.workableID, 
                            jacketID: that.jacketID, 
                            nodeName: pResults.node_name,
                            milestone: pResults.milestone
                        }
                        pPreviousDefer.notify(progressData);
                        that._dispatchEvent("progress", new ProgressEvent("progress", {lengthComputable: false}), progressData);
                    }
                    // waiting
                    pDefer.reject("wait");
                } else if (pResults !== undefined && pResults.no_results === true) {
                    var debugURL;
                    if (typeof pResults.workable_id === "string" && pResults.workable_id.length > 0) {
                        debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
                    } else {
                        debugURL = "/portal.cgi?quantum&whitepaperName=" + that.whitepaper;
                    }
                    console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
                    pDefer.reject({
                        "error": "no_results",
                        "debug": {
                            "debug_type": "workflow",
                            "whitepaperName": that.whitepaper,
                            "whitepaperInputName": that.inputname,
                            "jacketID": pResults.jacket_id,
                            "workableID": pResults.workable_id
                        }
                    });
                } else {
                    pDefer.resolve(pResults);
                } 
            }, function(pError){
               console.error(pError);
               pDefer.reject(pError);
            });
        });
    },
    
    /**
     * @description Just start and do not wait for results
     * @function
     * @name WhitepaperConnection#justStart
     * @return {Deferred}
     */
    justStart: function(pIgnoreCheckes) {
        if (pIgnoreCheckes !== true) {
            if (this.isStarted() === true) {
                return $.Deferred().reject({"error": "no_restart"});
            }
        }
        this.started = true;
        this.startDate = new Date();
        var that = this;
        return $.Deferred(function(pDefer){
            var files = [];
            if (Array.isArray(that.files)) {
                files = that.files;
            }
            api_async.hub.start_from_whitepaper_with_files_and_variables(that.whitepaper, that.inputname, files, that.inputparameters,
                function(pResults) {
                    that.workableID = pResults.workable_id;
                    that.jacketID = pResults.jacket_id;
                    pDefer.resolve({
                        workableID: that.workableID,
                        jacketID: that.jacketID
                    });
                },
                function(pError){
                    console.error(pError);
                    pDefer.reject(pError);
            });
        });
    },
    
    /**
     * @description Run a httpService. This will run a script on the server and will return directly. This does not requires workers or workables
     * @function
     * @name WhitepaperConnection#httpService
     * @return {Promise}
     */
    httpService: function() {
        var promiseDict = Promise.withResolvers();
        var xhttp = new XMLHttpRequest();
        xhttp.onload = function() {
            if (xhttp.status < 200 || (xhttp.status > 299)) {
                var errorObject = {
                    error_code: "http",
                    error: xhttp.statusText
                }
                if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
                    try {
                        errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
                    } catch(e) {}
                }
                promiseDict.reject(errorObject);
            } else {
                if (typeof xhttp.responseText === "string") {
                    let data = null;
                    if (xhttp.responseText.length === 0) {
                        promiseDict.resolve({});
                    } else if (xhttp.responseText.length > 0) {
                        try {
                            data = JSON.parse(xhttp.responseText);
                        } catch(e) {
                            promiseDict.reject({error_code: "content_not_json", error: e.message});
                            return;
                        }
                        promiseDict.resolve(data);
                    }
                } else {
                    promiseDict.reject({"error_code": "missing_response", "error": "response is missing"});
                }
            }
        }
        xhttp.onerror = function(){
            var errorObject = {
                error_code: "http_error_load",
                error: xhttp.statusText
            }
            if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
                try {
                    errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
                } catch(e) {}
            }
            promiseDict.reject(errorObject);
        }
        xhttp.onabort = function() {
            promiseDict.reject({error_code: "abort", error: "connection has been aborted"});
        }
        // encode to be able to pass a '#' charater
        xhttp.open("post", "/portal.cgi?http_service=" + encodeURIComponent(this.inputname) + "&whitepaper=" + encodeURIComponent(this.whitepaper));
        xhttp.setRequestHeader("Content-Type", "text/plain; charset=UTF-8");
        xhttp.send(JSON.stringify(this.inputparameters));
        return promiseDict.promise;
    },
    
    /**
     * @description If a workable is already fired, try to catch up and follow that workable.
     * So no need to create a second workable
     * @function
     * @name WhitepaperConnection#catchup
     * @param {Object} pJacketSettings containing workable_id and jacket_id
     * @return {Deferred}
     * @example whitepaperConnection.catchup({
     *      workable_id: "581afff771bc000000000005",
     *      jacket_id: "631ae550e0f1192dee5464f5",
     * });
     */
    catchup: function(pJacketSettings) {
        this.workableID = pJacketSettings.workable_id;
        this.jacketID = pJacketSettings.jacket_id;
        var that = this;
        return $.Deferred(function(pDefer){
            that._polling(pDefer);
        });
    }
};

/**
 * @description Is there a whitepaper with this specific name?
 * @function
 * @static
 * @name WhitepaperConnection.exist
 * @param {String} pWhitepaper the name of the workflow
 * @param {String} pInputName the start from kiosk
 * @returns {Deferred}
 */
WhitepaperConnection.exist = function(pWhitepaper, pInputName){
    return api_defer.hub.get_whitepaper_input_options(pWhitepaper, pInputName).then(function(pResults){
        if (pResults && typeof pResults === "object" && Object.keys(pResults).length > 0) {
            return true; 
        } else {
            return false; 
        } 
    }, function(pError) {
        if (pError !== undefined && pError.error_code === "WhitePaper not found") {
            return false;
        } else if (pError !== undefined && pError.error_code === "Input not found in WhitePaper") {
            return false;
        } else {
            console.error(pError);
            // other errors;
            return false;
        }
    });
};

/**
 * @description parse the input to a user friendly string
 * @function
 * @static
 * @name WhitepaperConnection.parseMilestone
 * @param {Mixed} pInput the input to parse
 * @param {String} pLanguage the current language of the user
 * @returns {String} parsed output
 */
WhitepaperConnection.parseMilestone = function(pInput, pLanguage = "en"){
    if (typeof pLanguage !== "string" || pLanguage.length <= 1) {
        throw new Error("parameter language is missing or invalid");
    }
    if (pInput === undefined || pInput === null) {
        return "";
    }
    if (pInput && typeof pInput === "object") {
        if (typeof pInput[pLanguage] === "string") {
            return pInput[pLanguage];
        } else if (typeof pInput["en"] === "string"){
            return pInput["en"];
        }
        return JSON.stringify(pInput);
    } else if (typeof pInput === "string" && pInput.length > 0) {
        try {
            var obj = JSON.parse(pInput);
            if (typeof obj[pLanguage] === "string") {
                return obj[pLanguage];
            } else if (typeof obj["en"] === "string"){
                return obj["en"];
            }
        } catch(e) {/* ignore it is a normal string*/}
    }
    return "" + pInput;
}

/**
 * @description only used for internal use, 
 * @param {String} pKey 
 * @param {Mixed} pValue 
 * @private
 */
WhitepaperConnection._setStatus = function(pKey, pValue){
    if (pKey === "_serverIsOverloaded") {
        _serverIsOverloaded = !!pValue;
    }
}

if (typeof window === "object") {
    if (window.addEventListener) {
// handle quitting page
// abort all running workables, if they are still running
    window.addEventListener("beforeunload", function(event) {
        for (var i = 0; i < connections.length; i++) {
            if (connections[i].hasLongLive() === true) {
                continue; // do not kill long lived connections
            }
            connections[i].stop("quit_page");
        }
    });
        document.addEventListener("visibilitychange", function(){
            if (document.hidden === true) {
                for (var i = 0; i < connections.length; i++) {
                    connections[i].pause();
                }
            } else if (document.hidden === false) {
                for (var i = 0; i < connections.length; i++) {
                    connections[i].resume();
                }
            }
        })
    }
    if (typeof window.BroadcastChannel === "function") {
        var nixpsBroadcast = new BroadcastChannel("nixps");
        nixpsBroadcast.onmessage = function(pEvent) {
            if (pEvent && pEvent.data) {
                if (pEvent.data.type === "nixps.error.server_overload") {
                    _serverIsOverloaded = true;
                } else if (pEvent.data.type === "nixps.error.server_overload_reset") {
                    _serverIsOverloaded = false;
                }
            }
        }
    }
}

module.exports = WhitepaperConnection;